import React from 'react';
import { IonIcon } from '@ionic/react';
import { barChartOutline } from 'ionicons/icons';
import './Loader.css';

const Loader = ({ message = 'Loading...' }) => {
  return (
    <div className="loader-container">
      <div className="loader-content">
        <div className="loader-spiral-wrapper">
          <div className="spiral-orbit"></div>
          <div className="spiral-orbit"></div>
          <div className="spiral-orbit"></div>
          <div className="spiral-center"></div>
        </div>

        <div className="space-y-2">
          <h2 className="loader-message">
            {message}
          </h2>

          <div className="loader-dots">
            <div className="loader-dot"></div>
            <div className="loader-dot"></div>
            <div className="loader-dot"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
